'use strict';

var _ = require('lodash');
var ImportCsvStatusController = function ImportCsvStatusController($scope, fileSaveService, importCsvUploadingService) {
  var HIDDEN_LINE_NUMBERS_HEPS = ['FOBusinessRules', 'FOTacticalFBCPatternConfig', 'FOTacticalFareIndex', 'FOAnalystPosMapping'];
  $scope.formatKey = function (key) {
    var parts = key.split('-');
    return parts.length > 2 ? _.dropRight(parts, 2).join('-') + ' (' + _.takeRight(parts, 2).join('-') + ')' : _.join(parts, '-');
  };
  $scope.showErrorsHeader = function (errorMessages) {
    return _.size(errorMessages) > 1;
  };
  $scope.showErrorsDownloadLink = function () {
    return $scope.displayDownloadLink && !importCsvUploadingService.hasFileLevelError($scope.errorMessages);
  };
  $scope.downloadErrorDump = function () {
    var fileName = _.replace($scope.$parent.chosenFileName, /.csv.*/i, '.txt');
    var hepName = _.replace($scope.$parent.chosenFileName, /.csv.*/i, '');
    var shouldHideLineNumbers = _.includes(HIDDEN_LINE_NUMBERS_HEPS, hepName);
    var headerFile = shouldHideLineNumbers ? ['Error Message'] : ['Line', 'Error Message'];
    var rows = _.reduce($scope.errorMessages, function (errors, errorMessage, errorLine) {
      if (Array.isArray(errorMessage)) {
        _.forEach(errorMessage, function (error) {
          errors.push(shouldHideLineNumbers ? error : errorLine + ',' + error);
        });
      } else {
        errors.push(shouldHideLineNumbers ? errorMessage : errorLine + ',' + errorMessage);
      }
      return errors;
    }, [headerFile.join(',')]);
    fileSaveService.createFile(rows.join('\r\n'), 'text/csv', 'Error-' + fileName);
  };
};
ImportCsvStatusController.$inject = ['$scope', 'FileSaveService', 'ImportCsvUploadingService'];
module.exports = ImportCsvStatusController;